export enum Roles {
  Admin = 'Admin'
};

export class Policies {
  static ProjectCreatePolicy: Roles[] = [Roles.Admin];
}
